var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-card",
        { staticClass: "auth-card relative-position" },
        [
          _c("q-card-main", [
            _c("h1", { staticClass: "text-center auth-card__heading" }, [
              _vm._v(_vm._s(_vm.$t("login_heading")))
            ]),
            _c("p", { staticClass: "text-center auth-card__description" }, [
              _vm._v(_vm._s(_vm.$t("login_description")))
            ]),
            _c(
              "form",
              {
                attrs: { id: "login-form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.handleLogin($event)
                  }
                }
              },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.errors.has("email"),
                      "error-label": _vm.errors.first("email")
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required",
                          expression: "'required'",
                          modifiers: { disable: true }
                        }
                      ],
                      attrs: {
                        name: "email",
                        type: "email",
                        "float-label": _vm.$t("email"),
                        required: "",
                        autofocus: ""
                      },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.errors.has("password"),
                      "error-label": _vm.errors.first("password")
                    }
                  },
                  [
                    _c("q-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate.disable",
                          value: "required",
                          expression: "'required'",
                          modifiers: { disable: true }
                        }
                      ],
                      ref: "password",
                      attrs: {
                        name: "password",
                        type: "password",
                        "float-label": _vm.$t("password"),
                        required: ""
                      },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password = $$v
                        },
                        expression: "password"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "auth-card__footer row justify-between" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-auto col-xs-12 self-center auth-card__secondary-action"
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "router-link",
                            attrs: { to: { name: "register" } }
                          },
                          [_vm._v(_vm._s(_vm.$t("register")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-auto col-xs-12 self-center auth-card__primary-action"
                      },
                      [
                        _c(
                          "q-btn",
                          { attrs: { type: "submit", color: "primary" } },
                          [_vm._v(_vm._s(_vm.$t("login")))]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c("q-inner-loading", { attrs: { visible: _vm.loading } })
        ],
        1
      ),
      _c(
        "router-link",
        {
          staticClass: "auth-page__bottom-link router-link",
          attrs: { to: { name: "forgot-password" } }
        },
        [_vm._v(_vm._s(_vm.$t("forgot_password")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }